<template>
  <div>
    <Head :title="client.name" />

    <!-- Header y Barra de herramientas -->
    <!-- Botón de regreso y título -->
    <div class="flex items-center mb-8">
      <a 
        class="mr-4 p-2.5 bg-teal-800 hover:bg-teal-900 text-white rounded-lg transition-colors" 
        :href="`/clients`"
        title="Volver"
      >
        <i class="fa fa-arrow-left"></i>
    </a>
      <h1 class="text-3xl font-bold flex items-center">
        <Link 
          class="text-blue-600 hover:text-blue-700 transition-colors" 
          href="/clients"
        >
          Clientes
        </Link>
        <span class="mx-2 text-gray-400">/</span>
        <span>{{ client.name }}</span>
      </h1>
    </div>

    <div class="flex justify-end space-x-4 mt-4">
      <!-- Botón de Editar Cliente -->
      <Link 
        :href="`/clients/${client.id}/edit`"
        class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        Editar cliente
      </Link>

      <!-- Botón de Registrar Pago 
      <Link 
        :href="`/clients/${client.id}/payments/create`"
        class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
      >
        <div class="fa fa-money"></div>
        Registrar Pago
      </Link> -->

      <!-- Botón de Estado de Cuenta -->
      <a
        :href="`/clients/${client.id}/statement`"
        class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-700 hover:bg-teal-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
      >
        <div class="fa fa-file-pdf"></div>
        Estado de Cuenta
     </a>
    </div>

    <!-- Información del Cliente -->
    <div class="bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Información Personal -->
          <div>
            <h2 class="text-lg font-semibold text-gray-800 mb-4">Información Personal</h2>
            <dl class="grid grid-cols-1 gap-4">
              <div>
                <dt class="text-sm font-medium text-gray-500">Nombre</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.name }}</dd>
              </div>
              <div>
                <dt class="text-sm font-medium text-gray-500">Identificación</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.identification }}</dd>
              </div>
              <div>
                <dt class="text-sm font-medium text-gray-500">Correo Electrónico</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.email }}</dd>
              </div>
              <div>
                <dt class="text-sm font-medium text-gray-500">Teléfono</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.phone }}</dd>
              </div>
            </dl>
          </div>

          <!-- Información de Empresa -->
          <div>
            <h2 class="text-lg font-semibold text-gray-800 mb-4">Información de Empresa</h2>
            <dl class="grid grid-cols-1 gap-4">
              <div>
                <dt class="text-sm font-medium text-gray-500">Tipo de Cliente</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.typeClient }}</dd>
              </div>
              <div>
                <dt class="text-sm font-medium text-gray-500">Nombre de Empresa</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.companyName }}</dd>
              </div>
              <div>
                <dt class="text-sm font-medium text-gray-500">Dirección</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ client.address }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado de Cuenta -->
    <div class="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="bg-white rounded-lg shadow-sm p-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-2">Balance</h3>
        <p class="text-3xl font-bold" :class="balanceTotal >= 0 ? 'text-green-600' : 'text-red-600'">
          {{ formatCurrency(balance) }}
        </p>
      </div>
      <div class="bg-white rounded-lg shadow-sm p-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-2">Deuda</h3>
        <p class="text-3xl font-bold" :class="balanceTotal >= 0 ? 'text-green-600' : 'text-red-600'">
          {{ formatCurrency(balanceTotal) }}
        </p>
      </div>
      <div class="bg-white rounded-lg shadow-sm p-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-2">Total Órdenes</h3>
        <p class="text-3xl font-bold text-blue-600">{{ totalOrders }}</p>
      </div>
      <div class="bg-white rounded-lg shadow-sm p-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-2">Total Gastado</h3>
        <p class="text-3xl font-bold text-green-600">{{ formatCurrency(totalSpent) }}</p>
      </div>
    </div>

    <!-- Historial de Órdenes -->
    <div class="mt-6 bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-800 mb-4">Historial de Órdenes</h2>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"># Orden</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Balance</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Responsable</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="order in orders.data" :key="order.id">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <Link :href="`/orders/${order.id}`" class="text-blue-600 hover:text-blue-900">
                    #{{ order.id }}
                  </Link>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ formatDate(order.created_at) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                    :class="getOrderStateClass(order.order_state)">
                    {{ getOrderStateLabel(order.order_state) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ formatCurrency(order.total) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm"
                  :class="order.balance >= 0 ? 'text-green-600' : 'text-red-600'">
                  {{ formatCurrency(order.balance) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ order.responsible.first_name }} {{ order.responsible.last_name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination 
          v-if="orders.links" 
          :links="orders.links" 
          class="mt-6"
        />
      </div>
    </div>

    <!-- Historial de Pagos -->
    <div class="mt-6 bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-800 mb-4">Historial de Pagos</h2>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
                <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"># Pago</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Método</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Referencia</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="payment in payments.data" :key="payment.id">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        <Link :href="`/payments/${payment.id}`" class="text-blue-600 hover:text-blue-900">
                            #{{ payment.id }}
                        </Link>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ formatDate(payment.created_at) }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ payment.method }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ payment.reference }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {{ formatCurrency(payment.amount) }}
                    </td>
                </tr>
            </tbody>
          </table>
        </div>

        <pagination 
          v-if="payments.links" 
          :links="payments.links" 
          class="mt-6"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import AppToolbar from '@/Shared/AppToolbar.vue'
import { formatDate, formatCurrency } from '@/utils/format'
import { getOrderStateClass, getOrderStateLabel } from '@/utils/orderStates'

export default {
  name: 'ClientShow',

  components: {
    Head,
    Link,
    Pagination,
    AppToolbar,
  },

  layout: Layout,

  props: {
    client: Object,
    balanceTotal: Number,
    orders: Object,
    totalOrders: Number,
    totalSpent: Number,
    balance: Number,
    payments: Object,
  },

  methods: {
    formatDate,
    formatCurrency,
    getOrderStateClass,
    getOrderStateLabel,
  },
}
</script> 